import {toString} from 'lodash/lang'
import { trim } from "lodash/string";

export function isYourTube(src) {
  src = toString(src).replace(' ', '');

  return src.indexOf('youtu.be') !== -1 || src.indexOf('youtube') !== -1;
}

export function makeYourTubeEmbed(url, defaultValue) {
  if(!isYourTube(url)) {
    return url;
  }

  try {
    const regex = RegExp('(?<=v=)[a-zA-Z0-9-_]+(?=&)|(?<=[0-9]/)[^&\\n]+|(?<=v=)[^&\\n]+|(?<=be\\/)[a-zA-Z0-9-_]+');
    let src = toString(url).replace(' ', '');

    const match = regex.exec(src);

    return match ? `https://www.youtube.com/embed/${match}` : defaultValue;
  } catch (e) {
    return defaultValue;
  }

}

/**
 * @TODO: add slug to api object
 * @param link
 * @return {string|*}
 */
export function linkToSlug(link) {
  return trim(link, '/')
}
